<div [ngClass]="innerModal ? 'servc-modal inner-modal' : 'servc-modal'">
  <div [ngClass]="bigSize ? 'inner-container' : 'inner-container-small'" class="modal-box-shadow" #spinnerDiv>
    <div class="flex items-start gap-[0.5rem] {{titleDirection === 'centered' ? 'justify-center' : 'justify-start'}}">
      @if (buttons?.back) {
        <button type="button" class="modal-button back-button-size"
          (click)="closeButtonClicked.emit()">
          <svg class="svg-arrow-back" width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"
              fill="#00948e" />
          </svg>
          {{backString}}
        </button>
      }
      @if (title) {
        <div
          data-qa="modal-container-title"
          [ngClass]="{'min-h-[2.125rem]' : buttons.upperRight1 || buttons.upperRight2}"
          class="{{bigSize ? 'title-2 bold700 max-w-[26rem]' : 'font-1 bold600'}} flex flex-row items-center justify-start {{titleStyles}}" [innerHTML]="title">
          @if (greenTitle) {
            <span data-qa="modal-container-green-title" class="main-8"> {{greenTitle}}</span>
          }
        </div>
      }

      @if (buttons?.upperRight1 || buttons?.upperRight2) {
        <div class="flex flex-row items-center justify-center gap-[0.5rem]">
          @if (buttons.upperRight1) {
            <button type="button" class="modal-button button-size {{buttons.upperRight1Class}}"
              (click)="upperRight1ButtonClicked.emit()">
              {{buttons.upperRight1}}
            </button>
          }
          @if (buttons?.upperRight2) {
            <div [ngClass]="{'cursor-not-allowed': !upperRight2Activated}">
              <button type="button" class="modal-button button-size {{buttons.upperRight2Class}}"
                (click)="upperRight2ButtonClicked.emit()" [disabled]="!upperRight2Activated">
                {{buttons.upperRight2}}
              </button>
            </div>
          }
        </div>
      }
    </div>
    @if (bigSize && title) {
      <div class="whitespace-1"></div>
    }
    @if (bigSize && title) {
      <div class="black-line for-p-[1.25rem]"></div>
    }
    @if (subtitle) {
      <div class="whitespace-0p5"></div>
    }
    @if (subtitle) {
      <div class="modal-subtitle">
        {{subtitle}}
      </div>
    }

    @if (title && showWhiteSpace) {
      <div class="whitespace-1p25"></div>
    }
    <!-- Your code is down here-->
    <ng-content></ng-content>
    <!-- Your code is  up  here-->
    @if (buttons && (buttons.apply || buttons.dismiss || buttons.lowerLeft)) {
      <div class="whitespace-1p25"></div>
    }

    @if (!buttons?.lowerLeft && !buttons?.dismissApplyAlignRight) {
      <div class="flex flex-row items-center justify-center gap-[0.5rem]" >
        @if (buttons?.dismiss) {
          <app-button
            data-qa="modal-container-dismiss-button"
            [size]="'modal-container-button'"
            [type]="'default'"
            [additionalClasses]="'!w-[6rem]'"
            (buttonClick)="dismissButtonClicked.emit()">
            {{buttons.dismiss}}
          </app-button>
        }
        <div [ngClass]="{'cursor-not-allowed': !applyActivated}" title="{{applyHint}}">
          @if (buttons?.apply) {
            <app-button
              data-qa="modal-container-apply-button"
              [size]="'modal-container-button'"
              [type]="'accent'"
              [additionalClasses]="buttons.applySize ?? '!w-[6rem]'"
              [disabled]="!applyActivated"
              (buttonClick)="applyButton()">
              {{buttons.apply}}
            </app-button>
          }
        </div>
      </div>
    }

    @if (buttons && (buttons.lowerLeft || buttons.dismissApplyAlignRight)) {
      <div
        [ngClass]="buttons.dismissApplyAlignRight ?'modal-align-right-row':'modal-spacebetween-row'">
        <div [ngClass]="{'cursor-not-allowed': !lowerLeftActivated}" title="{{lowerLeftHint}}">
          @if (buttons.lowerLeft) {
            <app-button
              data-qa="modal-container-lower-left-button"
              [size]="'modal-container-button'"
              [type]="buttons.lowerLeftClass ?? 'default'"
              [disabled]="!lowerLeftActivated"
              [showIcon]="buttons.lowerLeftIcon ? 'left' : null"
              [iconName]="buttons.lowerLeftIcon"
              (buttonClick)="lowerLeftButtonClicked.emit()">
              {{buttons.lowerLeft}}
            </app-button>
          }
        </div>
        <div class="flex flex-row items-center justify-center gap-[0.5rem]">
          @if (buttons.dismiss) {
            <app-button
              data-qa="modal-container-dismiss-button"
              [size]="'modal-container-button'"
              [type]="'default'"
              [additionalClasses]="'!w-[6rem]'"
              (buttonClick)="dismissButtonClicked.emit()">
              {{buttons.dismiss}}
            </app-button>
          }
          <div [ngClass]="{'cursor-not-allowed': !applyActivated}" title="{{applyHint}}">
            @if (buttons.apply) {
              <app-button
                data-qa="modal-container-apply-button"
                [size]="'modal-container-button'"
                [type]="'accent'"
                [disabled]="!applyActivated"
                [additionalClasses]="'!w-[6rem]'"
                (buttonClick)="applyButton()">
                {{buttons.apply}}
              </app-button>
            }
          </div>
        </div>
      </div>
    }

    @if (buttons?.close) {
      <div
        data-qa="modal-container-close-button"
        class="close-modal"
        (click)="closeButtonClicked.emit()">
        <app-all-icons [iconNameAndStyling]="'close.svg; white-12; icon-size-1p5'"/>
      </div>
    }
  </div>
</div>
